import React, { Suspense } from 'react';

// The 404 route is statically imported so an unmatched URL can always
// render, network or no network. Its robot animation should not be part
// of that promise: react-lottie pulls lottie-web, 278 KB measured, for a
// decoration on a page most people never see. It is fetched only when the
// 404 actually renders, and the box it will occupy is reserved first so
// nothing shifts when it lands.
const NotFoundAnimation = React.lazy(() => import('./NotFoundAnimation'));

const ANIMATION_SIZE = 400;

export default function PageNotFound() {
  return (
    <div>
      <Suspense
        fallback={
          <div
            style={{ height: ANIMATION_SIZE, width: ANIMATION_SIZE }}
            aria-hidden="true"
          />
        }
      >
        <NotFoundAnimation size={ANIMATION_SIZE} />
      </Suspense>
    </div>
  );
}
